var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxCircleChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8634 20.9999C12.5874 20.9999 12.3234 20.8859 12.1344 20.6849L7.27138 15.5059C6.89238 15.1039 6.91338 14.4709 7.31538 14.0929C7.71838 13.7149 8.35138 13.7349 8.72838 14.1369L12.8534 18.5279L21.2614 9.32587C21.6354 8.91687 22.2674 8.88987 22.6754 9.26187C23.0824 9.63387 23.1104 10.2669 22.7384 10.6739L13.6014 20.6739C13.4144 20.8799 13.1484 20.9979 12.8704 20.9999H12.8634Z",
    fill: "#00E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxCircleChecked);
export default __webpack_public_path__ + "static/media/checkbox-circle-checked.d7e772cfde8b2a158130543c17d26649.svg";
export { ForwardRef as ReactComponent };